// Author Lidongxu
// Date 2025-06-03 13:04:53

class EmStocktakingTaskDetail {
constructor({
        id = null,
        taskId = '',
        arcTypeLevelOne = '',
        arcTypeLevelTwo = '',
        arcTypeLevelThree = '',
        arcName = '',
        arcCode = '',
        arcSize = '',
        arcUnit = '',
        expectedBin = '',
        actualBin = '',
        expectedQuantity = '',
        actualQuantity = '',
        epcCode = '',
        stocktakeStatus = '',
        stocktakeDate = '',
        remark = ''}
= {}) {
    this.id = id;
    this.taskId = taskId;
    this.arcTypeLevelOne = arcTypeLevelOne;
    this.arcTypeLevelTwo = arcTypeLevelTwo;
    this.arcTypeLevelThree = arcTypeLevelThree;
    this.arcName = arcName;
    this.arcCode = arcCode;
    this.arcSize = arcSize;
    this.arcUnit = arcUnit;
    this.expectedBin = expectedBin;
    this.actualBin = actualBin;
    this.expectedQuantity = expectedQuantity;
    this.actualQuantity = actualQuantity;
    this.epcCode = epcCode;
    this.stocktakeStatus = stocktakeStatus;
    this.stocktakeDate = stocktakeDate;
    this.remark = remark;
}
}

function newEntity() {
return new EmStocktakingTaskDetail();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'taskId',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.taskId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'taskCode',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.taskCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'taskBusinessType',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.taskBusinessType',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '工具/刀具' },
                            { value: '2', text: '吊索具' },
                            { value: '3', text: '固定资产' },
                            { value: '4', text: '工装' },{ value: '5', text: '量器具' }
            ]
                }
        },
        {
        key: 'arcTypeLevelOne',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.arcTypeLevelOne',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'arcTypeLevelTwo',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.arcTypeLevelTwo',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'arcTypeLevelThree',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.arcTypeLevelThree',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'arcName',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.arcName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'arcCode',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.arcCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'arcSize',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.arcSize',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'arcUnit',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.arcUnit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'expectedBin',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.expectedBin',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'actualBin',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.actualBin',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'expectedQuantity',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.expectedQuantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'actualQuantity',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.actualQuantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'epcCode',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.epcCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'stocktakeStatus',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.stocktakeStatus',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '0', text: '未盘点' },
                            { value: '1', text: '盘点完成' },
                            { value: '2', text: '补盘点完成' }
            ]
                }
        },
        {
        key: 'stocktakeDate',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.stocktakeDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emStocktakingTaskDetail.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    taskIdFilter : '',
    arcTypeLevelOneFilter : '',
    arcTypeLevelTwoFilter : '',
    arcTypeLevelThreeFilter : '',
    arcNameFilter : '',
    arcCodeFilter : '',
    arcSizeFilter : '',
    arcUnitFilter : '',
    expectedBinFilter : '',
    actualBinFilter : '',
    expectedQuantityFilter : '',
    actualQuantityFilter : '',
    epcCodeFilter : '',
    stocktakeStatusFilter : '',
    stocktakeDateRteFilter : '',
    stocktakeDateLteFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'taskIdFilter',
        label: 'label.em.archive.emStocktakingTaskDetail.filter.taskId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emStocktakingTask'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'arcTypeLevelOneFilter',
        label: 'label.em.archive.emStocktakingTaskDetail.filter.arcTypeLevelOne',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'arcTypeLevelTwoFilter',
        label: 'label.em.archive.emStocktakingTaskDetail.filter.arcTypeLevelTwo',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'arcTypeLevelThreeFilter',
        label: 'label.em.archive.emStocktakingTaskDetail.filter.arcTypeLevelThree',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'arcNameFilter',
        label: 'label.em.archive.emStocktakingTaskDetail.filter.arcName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'arcCodeFilter',
        label: 'label.em.archive.emStocktakingTaskDetail.filter.arcCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'arcSizeFilter',
        label: 'label.em.archive.emStocktakingTaskDetail.filter.arcSize',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'arcUnitFilter',
        label: 'label.em.archive.emStocktakingTaskDetail.filter.arcUnit',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'expectedBinFilter',
        label: 'label.em.archive.emStocktakingTaskDetail.filter.expectedBin',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'actualBinFilter',
        label: 'label.em.archive.emStocktakingTaskDetail.filter.actualBin',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'expectedQuantityFilter',
        label: 'label.em.archive.emStocktakingTaskDetail.filter.expectedQuantity',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'actualQuantityFilter',
        label: 'label.em.archive.emStocktakingTaskDetail.filter.actualQuantity',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'epcCodeFilter',
        label: 'label.em.archive.emStocktakingTaskDetail.filter.epcCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'stocktakeStatusFilter',
        label: 'label.em.archive.emStocktakingTaskDetail.filter.stocktakeStatus',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '0', text: '未盘点' },
                { value: '1', text: '盘点完成' },
                { value: '2', text: '补盘点完成' }
            ]
        }
        },
        {
        key: 'stocktakeDateRteFilter',
        label: 'label.em.archive.emStocktakingTaskDetail.filter.stocktakeDateRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'stocktakeDateLteFilter',
        label: 'label.em.archive.emStocktakingTaskDetail.filter.stocktakeDateLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'taskId',
        label: 'label.em.archive.emStocktakingTaskDetail.entity.taskId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emStocktakingTask'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'arcTypeLevelOne',
        label: 'label.em.archive.emStocktakingTaskDetail.entity.arcTypeLevelOne',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'arcTypeLevelTwo',
        label: 'label.em.archive.emStocktakingTaskDetail.entity.arcTypeLevelTwo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'arcTypeLevelThree',
        label: 'label.em.archive.emStocktakingTaskDetail.entity.arcTypeLevelThree',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'arcName',
        label: 'label.em.archive.emStocktakingTaskDetail.entity.arcName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'arcCode',
        label: 'label.em.archive.emStocktakingTaskDetail.entity.arcCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'arcSize',
        label: 'label.em.archive.emStocktakingTaskDetail.entity.arcSize',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'arcUnit',
        label: 'label.em.archive.emStocktakingTaskDetail.entity.arcUnit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'expectedBin',
        label: 'label.em.archive.emStocktakingTaskDetail.entity.expectedBin',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'actualBin',
        label: 'label.em.archive.emStocktakingTaskDetail.entity.actualBin',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'expectedQuantity',
        label: 'label.em.archive.emStocktakingTaskDetail.entity.expectedQuantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'actualQuantity',
        label: 'label.em.archive.emStocktakingTaskDetail.entity.actualQuantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'epcCode',
        label: 'label.em.archive.emStocktakingTaskDetail.entity.epcCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'stocktakeStatus',
        label: 'label.em.archive.emStocktakingTaskDetail.entity.stocktakeStatus',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '0', text: '未盘点' },
                { value: '1', text: '盘点完成' },
                { value: '2', text: '补盘点完成' }
            ]
        }
        },
        {
        key: 'stocktakeDate',
        label: 'label.em.archive.emStocktakingTaskDetail.entity.stocktakeDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emStocktakingTaskDetail.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {EmStocktakingTaskDetail, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
